import { Text } from '@croquiscom-pvt/zds';
import { Vars, vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { TextOverFlowCss } from '@domains/storehome-common';

interface Props {
  name: string;
  description: string;
  title_color?: keyof Vars['color'];
  description_color?: keyof Vars['color'];
  badge?: string[];
}

export const SelectedShopBasicInfo = ({
  name,
  description,
  title_color = 'textStrong',
  description_color = 'textTertiary',
  badge = [],
}: Props) => {
  return (
    <Information>
      <ShopNameWrapper>
        <Text
          as='h2'
          variant='Head_20_Bold'
          color={title_color}
          css={css`
            margin: 0 0 4px 0;
            line-height: 24px;
            ${TextOverFlowCss}
          `}
        >
          {name}
        </Text>
        {badge.map((badge) => (
          <Badge key={badge} as='span' variant='Caption_10_Medium' color='textSecondary' backgroundColor='#F5F6F8'>
            {badge}
          </Badge>
        ))}
      </ShopNameWrapper>
      <Text as='p' variant='Caption_12_Medium' color={description_color} css={TextOverFlowCss}>
        {description}
      </Text>
    </Information>
  );
};

const Information = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const ShopNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Badge = styled(Text)<{ backgroundColor: string }>`
  padding: 2px 4px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
